import cn from 'classnames';

import type { Config, Id } from '../../config';
import { Chip } from './chip';
import { Empty } from './empty';
import css from './table.module.scss';

interface Props {
    section: Config[Id];
    onSelect(id: Id): void;
}
export function Table({ section, onSelect }: Props) {
    const { label, data, issues } = section;

    return (
        <>
            <div className={css.header}>
                <span>{label}</span>
                <span>Value</span>
            </div>

            <ul className={css.list}>
                {Array.from(data.entries()).map(([key, value]) => {
                    const issue = issues?.get(key);

                    return (
                        <li
                            key={key}
                            className={cn(css.item, {
                                [css.warning]: issue?.severity === 'warning',
                                [css.error]: issue?.severity === 'error',
                            })}
                        >
                            <span className={css.name}>
                                {issue && <Chip issue={issue} />}
                                <span>{key}</span>
                            </span>

                            {key === 'x-petm-decisions' ? (
                                <button type="button" className={css.link} onClick={() => onSelect('flags')}>
                                    View feature flags ›
                                </button>
                            ) : (
                                <span className={css.value}>{value}</span>
                            )}
                        </li>
                    );
                })}
            </ul>
            {data.size === 0 && <Empty />}
        </>
    );
}
